"use client";

import { useState, useEffect, useRef } from "react";
import { CPA_OFFERS, selectWeightedOffer } from "@/lib/cpa-offers";
import { CPAOfferCard } from "@/components/cpa-offer-card";

interface CountdownCPAOfferProps {
  excludeOfferId: string | null;
  onOfferClick: (offerId: string, link: string) => void;
  onOfferShown: (offerId: string) => void;
}

export function CountdownCPAOffer({
  excludeOfferId,
  onOfferClick,
  onOfferShown,
}: CountdownCPAOfferProps) {
  const [offer] = useState(() =>
    selectWeightedOffer(CPA_OFFERS, excludeOfferId)
  );
  const hasFiredShownEvent = useRef(false);

  useEffect(() => {
    if (!offer || hasFiredShownEvent.current) return;
    hasFiredShownEvent.current = true;
    onOfferShown(offer.id);
  }, [offer, onOfferShown]);

  if (!offer) return null;

  return (
    <div
      className="text-left animate-reveal-in"
      style={{ animationDelay: "100ms" }}
    >
      <CPAOfferCard
        offer={offer}
        onClick={() => onOfferClick(offer.id, offer.link)}
        ctaLabel={`Get ${offer.ctaAmount}`}
        mobileCTALabel={`Get ${offer.ctaAmount}`}
        data-testid="countdown-cpa-offer-link"
      />
    </div>
  );
}
